<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-image-file`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.171 2a2 2 0 011.415.586l5.828 5.831A2 2 0 0142 9.831V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h26.171zM32 6H10v36h28V12.038l-5 .001a1 1 0 01-1-1L31.999 6zm2.767 17.366a.8.8 0 01.234.565V36.4a.6.6 0 01-.6.6H21.449l-.013-.001-8.545.001a.6.6 0 01-.427-1.022l7.458-7.537a.8.8 0 011.13-.006h.002l3.768 3.742 8.812-8.811a.8.8 0 011.132 0zM19 17a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4z"/></svg>
</template>
<script>

export default {
  name: 'IconImageFile',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
